if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends window.BAO.CustomElement() {
      requiredEls = ['trigger']

      connectedCallback () {
        if (!this.els.trigger) {
          console.error(
            '[data-back-to-top-el="trigger"] is missing from the DOM',
          )
          return
        }

        this.setupListeners()
      }

      setupListeners () {
        super.setupListeners()

        this.listeners.add(window, 'scroll', this.onScroll.bind(this))
        this.listeners.add(
          this.els.trigger.element,
          'click',
          this.scrollToTop.bind(this),
        )
      }

      onScroll () {
        const y = window.scrollY
        y >= 1000
          ? this.els.trigger.element.setAttribute('aria-hidden', false)
          : this.els.trigger.element.setAttribute('aria-hidden', true)
      }

      scrollToTop () {
        window.scroll({
          top: 0,
          behavior: 'smooth',
        })
      }
    },
  )
}
